import React from 'react';
import { StyleSheet } from 'react-native';

import { Box, Row } from '@/components/lib/components';

import { CARD_GAP } from '../../utils/constants';
import { TiledGroup } from '../../utils/tiled-groups';
import { CasinoGameCardBase } from '../CasinoGameCardBase';

type TiledGroupCardProps = {
    group: TiledGroup;
    groupSize: number;
};

export const TiledGroupCard = ({ group, groupSize }: TiledGroupCardProps) => {
    if (group.kind === 'hero') {
        return (
            <Box width={groupSize}>
                <CasinoGameCardBase
                    game={group.game}
                    cardHeight={groupSize}
                    cardWidth={groupSize}
                    imageHeight={groupSize}
                    customNameVariant="titleMedium"
                />
            </Box>
        );
    }

    const tileSize = (groupSize - CARD_GAP) / 2;

    return (
        <Box width={groupSize} style={styles.quadGroup}>
            {[group.games.slice(0, 2), group.games.slice(2, 4)].map((rowGames, rowIndex) => (
                <Row key={rowIndex} style={styles.quadRow}>
                    {rowGames.map(game => (
                        <CasinoGameCardBase
                            key={game.id}
                            game={game}
                            cardHeight={tileSize}
                            cardWidth={tileSize}
                            imageHeight={tileSize}
                        />
                    ))}
                </Row>
            ))}
        </Box>
    );
};

const styles = StyleSheet.create({
    quadGroup: {
        gap: CARD_GAP,
    },
    quadRow: {
        gap: CARD_GAP,
    },
});
